import { requestHelpers } from '../../helpers';
import { browserHistory } from 'react-router';

const actions = {
    GET_BASKET: 'GET_BASKET',
    SET_BASKET: 'SET_BASKET',
    GET_ADD_PRODUCT_TO_BASKET: 'GET_ADD_PRODUCT_TO_BASKET',
    SET_ADD_PRODUCT_TO_BASKET: 'SET_ADD_PRODUCT_TO_BASKET',
    GET_ADD_PACKAGE_TO_BASKET: 'GET_ADD_PACKAGE_TO_BASKET',
    SET_ADD_PACKAGE_TO_BASKET: 'SET_ADD_PACKAGE_TO_BASKET',
    SET_REMOVE_PRODUCT_FROM_BASKET: 'SET_REMOVE_PRODUCT_FROM_BASKET',
    POST_REMOVE_PRODUCT_FROM_BASKET: 'POST_REMOVE_PRODUCT_FROM_BASKET',
    SET_REMOVE_PACKAGE_FROM_BASKET: 'SET_REMOVE_PACKAGE_FROM_BASKET',
    POST_REMOVE_PACKAGE_FROM_BASKET: 'POST_REMOVE_PACKAGE_FROM_BASKET',
    GET_PROCEED_TO_CHECKOUT: 'GET_PROCEED_TO_CHECKOUT',
    SET_PROCEED_TO_CHECKOUT: 'SET_PROCEED_TO_CHECKOUT',
    SET_CLEAR_BASKET: 'SET_CLEAR_BASKET',
    POST_CLEAR_BASKET: 'POST_CLEAR_BASKET',
    SET_PRICE_FOR_BASKET: 'SET_PRICE_FOR_BASKET',
    ORDER_BASKET: 'ORDER_BASKET',
    SET_PAYMENT_URL: 'SET_PAYMENT_URL',
    CLEAR_BASKET_ON_PAYMENT: 'CLEAR_BASKET_ON_PAYMENT',
};

function getBasket() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_BASKET,
        } );

        requestHelpers
            .authenticatedGetRequest( '/transactions/baskets/personal' )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_BASKET,
                    basket: response.data,
                } );
            } )
    };
}

export function addProductToBasket( productId ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_ADD_PRODUCT_TO_BASKET,
        } );

        requestHelpers
            .authenticatedPostRequest( '/transactions/baskets/personal/products', { product_id: productId } )
            .then( () => {
                dispatch( {
                    type: actions.SET_ADD_PRODUCT_TO_BASKET,
                    product: productId,
                } );
            } );
    };
}

function addPackageToBasket( packageId ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_ADD_PACKAGE_TO_BASKET,
        } );

        requestHelpers
            .authenticatedPostRequest( '/transactions/baskets/personal/packages', { package_id: packageId } )
            .then( () => {
                dispatch( {
                    type: actions.SET_ADD_PACKAGE_TO_BASKET,
                    package: packageId,
                } );
            } );
    };
}

function removeProductFromBasket( productId ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.SET_REMOVE_PRODUCT_FROM_BASKET,
            productId,
        } );

        requestHelpers
            .authenticatedPostRequest( `/transactions/baskets/personal/products/${ productId }`, {}, 'DELETE' )
            .then( () => {
                dispatch( {
                    type: actions.POST_REMOVE_PRODUCT_FROM_BASKET,
                    product: productId,
                } );
            } );
    };
}

function removePackageFromBasket( packageId ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.SET_REMOVE_PACKAGE_FROM_BASKET,
            packageId,
        } );

        requestHelpers
            .authenticatedPostRequest( `/transactions/baskets/personal/packages/${ packageId }`, {}, 'DELETE' )
            .then( () => {
                dispatch( {
                    type: actions.POST_REMOVE_PACKAGE_FROM_BASKET,
                    package: packageId,
                } );
            } );
    };
}

function clearBasket() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.SET_CLEAR_BASKET,
        } );

        requestHelpers
            .authenticatedPostRequest( '/transactions/baskets/personal', {}, 'DELETE' )
            .then( () => {
                dispatch( {
                    type: actions.POST_CLEAR_BASKET,
                } );
            } );
    }
}

function createPayment( personId, bankTransfer = false, total, recurringPrice = 0 ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.ORDER_BASKET,
        } );
        
        const _bankTransfer = bankTransfer ? 1 : 0;

        requestHelpers
            .authenticatedPostRequest( '/transactions/baskets/personal/order', { person_id: personId, bank_transfer: _bankTransfer, price: total, recurring_price: recurringPrice } )
            .then( ( response ) => {
                return dispatch( {
                    type: actions.SET_PAYMENT_URL,
                    url: response.data.url,
                } );
            }, ( error ) => {
                
            } );
    };
}

function setPriceForBasket( personId, price, hasVAT ) {

    const VAT = hasVAT ? 1 : 0;

    price = parseInt( price, 10 );

    return ( dispatch ) => {
        requestHelpers
            .authenticatedPostRequest( "/transactions/baskets/site/price", { person_id: personId, price, add_vat: VAT }, "PUT" )
            .then( () => {
                dispatch( {
                    type: actions.SET_PRICE_FOR_BASKET,
                    total: price,
                    VATApplied: hasVAT,
                } );
            }, ( error ) => {
                
            } );
    };
}

function setTotal( total ){
    return ( dispatch ) => {
        dispatch( {
            type: actions.SET_PRICE_FOR_BASKET,
            total,
            VATApplied: 1,
        } );

    };
}

module.exports = {
    actions,
    getBasket,
    addProductToBasket,
    addPackageToBasket,
    removeProductFromBasket,
    removePackageFromBasket,
    clearBasket,
    createPayment,
    setPriceForBasket,
    setTotal,
};



// WEBPACK FOOTER //
// src/client/actions/transactions/basket.js